


























































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue } from 'vue-property-decorator'
import { APIProduct } from '../../models/api/product.model'

@Component
export default class MessagesForm extends Vue {
    loading = true
    data: {[key: string]: unknown} = {}

    cardTitle = ''

    buttonLoading = false
    carrierId = null
    providerId = null
    productList: APIProduct[]

    formData: {[key: string]: any} = {
        messageEnabled: true,
        typeId: {
            id: null
        }
    }

    formValid = false
    formRules = {
        required: [
            (v: string) => !!v || 'This field is required'
        ],
        message: [
            (v: string) => !!v || 'This field is required',
            (v: string) => (v && v.length <= 255) || 'Field must be less than 255 characters'
        ]
    }

    formModel: { products: object[]; types: object[] } = {
        products: [],
        types: [
            {
                text: 'subscription',
                value: 'subscription'
            },
            {
                text: 'unsubscription',
                value: 'unsubscription'
            },
            {
                text: 'renewal',
                value: 'renewal'
            },
            {
                text: 'optin',
                value: 'optin'
            },
            {
                text: 'optout',
                value: 'optout'
            },
            {
                text: 'invalid_keyword',
                value: 'invalid_keyword'
            },
            {
                text: 'already_subscribed',
                value: 'already_subscribed'
            },
            {
                text: 'help',
                value: 'help'
            },
            {
                text: 'test',
                value: 'test'
            },
            {
                text: 'not_subscribed',
                value: 'not_subscribed'
            },
            {
                text: 'request_pin',
                value: 'request_pin'
            },
            {
                text: 'womco_info',
                value: 'womco_info'
            },
            {
                text: 'womco_info',
                value: 'womco_info'
            },
            {
                text: 'womco_indice',
                value: 'womco_indice'
            },
            {
                text: 'womco_queja',
                value: 'womco_queja'
            },
            {
                text: 'womco_ver',
                value: 'womco_ver'
            },
            {
                text: 'renew',
                value: 'renew'
            },
            {
                text: 'info',
                value: 'info'
            }
        ]
    }

    async mounted () {
        if (!this.$route.params.action) {
            this.$store.commit('reportError', { code: 1000, message: 'Error, not action sended in route params :(' })
            return
        }

        await Promise.all([
            this.getProducts()
        ])

        switch (this.$route.params.action) {
        case 'edit':
            this.cardTitle = 'Edit Message'
            this.getData()
            break
        case 'add':
            this.cardTitle = 'Create Message'
            this.data = {}
            this.loading = false
            break
        }
    }

    getProducts () {
        return new Promise<void>(resolve => {
            this.$store.dispatch('getProducts')
                .then(resp => {
                    if (resp.status === 200) {
                        const productItems = this.$store.state?.ProductsStore?.products.map((p: { productId: number; productName: string }) => {
                            return {
                                value: p.productId,
                                text: p.productName
                            }
                        })
                        this.formModel.products = productItems
                        resolve()
                    }
                })
        })
    }

    getData () {
        this.loading = true
        if (!this.$route.params.id) {
            this.$store.commit('reportError', { code: 1000, message: 'Error, not id sended in route params :(' })
            this.loading = false
            return
        }
        this.$store.dispatch('getMessagesById', this.$route.params.id)
            .then(resp => {
                if (resp?.status === 200) {
                    this.formData = this.$store.state.MessagesStore.messageForm
                    this.formData.productId = this.formData.productId?.productId
                    this.loading = false
                }
            })
    }

    async validateForm () {
        await (this.$refs.form as Vue & { validate: () => boolean }).validate()
        if (!this.formValid) return

        this.buttonLoading = true

        switch (this.$route.params.action) {
        case 'edit':
            this.$store.dispatch('editMessages', this.formData)
                .then(resp => {
                    this.buttonLoading = false
                    if (resp?.status === 200) {
                        this.$store.commit('reportSuccess', 'Done Successfully!')
                        this.$router.push({
                            name: 'Messages'
                        }).then(() => {
                            this.buttonLoading = false
                        })
                    }
                })
            break
        case 'add':
            this.$store.dispatch('createMessages', this.formData)
                .then(resp => {
                    this.buttonLoading = false
                    if (resp?.status === 200) {
                        this.$store.commit('reportSuccess', 'Done Successfully!')
                        this.$router.push({
                            name: 'Messages'
                        }).then(() => {
                            this.buttonLoading = false
                        })
                    }
                })
            break
        }
    }

    getDateFormat (dateString: string) {
        const date = new Date(dateString)
        const day = date.getDate().toString().padStart(2, '0')
        const month = date.getMonth().toString().padStart(2, '0')
        const year = date.getFullYear().toString().padStart(4, '0')
        const hours = date.getHours().toString().padStart(2, '0')
        const minutes = date.getMinutes().toString().padStart(2, '0')
        return `${day}/${month}/${year} - ${hours}:${minutes}`
    }
}
